// extracted by mini-css-extract-plugin
export default {"container":"styles_container__C8gbq","studies":"styles_studies__Wzpx-","title":"styles_title__K41dw","updated":"styles_updated__Zflo9"};